import * as axios from 'axios'
import { location } from '@/infrastructure/Configuration'
import ComponentsService from '@/services/ComponentsService'

axios.defaults.headers.common['Accept-Language'] = location
axios.defaults.timeout = 30000

export const componentsService = new ComponentsService(axios)
